<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<a id="p3">
</a><div class="illustype_image"><a id="p3"></a><div class="image_wrap"><a id="p3"></a><a href="http://www.chroniclebooks.com/" target="_blank"><img alt="e9780811866989_i0001.jpg" src="images/e9780811866989_i0001.jpg"/></a></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?44b1f1b4